<template>
  <div class="project-overview">
    <ProjectLayout/>
    <div class="overview-container first">
      <div class="overview-container_title text-center">{{ $t("project.chart.project_amount") }}</div>
      <div class="overview-container_chart">
        <ProjectAmount/>
      </div>
    </div>
    <div class="overview-container manmonth-count">
      <div class="overview-container_title text-center">{{ $t("project.chart.manmonth_amount") }}</div>
      <div class="overview-container_chart">
        <ManmonthAmount/>
      </div>
    </div>
    <div class="row manager-statistic">
      <div class="col pr-0">
        <div class="overview-container">
          <div class="overview-container_title text-center">{{ $t("project.chart.person_in_charge_projects") }}</div>
          <div class="overview-container_chart">
            <PersonInChargeProjects/>
          </div>
        </div>
      </div>
      <div>
        <svg width="1" height="100%" viewBox="0 0 1 488" fill="none" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="none">
          <line x1="0.5" y1="2.18557e-08" x2="0.499979" y2="488" stroke="#CFCFCF" stroke-dasharray="8 8"/>
        </svg>
      </div>
      <div class="col pl-0">
        <div class="overview-container">
          <div class="overview-container_title text-center">{{ $t("project.chart.person_in_charge_manmonth") }}</div>
          <div class="overview-container_chart">
            <PersonInChargeManmonth/>
          </div>
        </div>
      </div>
    </div>
    <div class="overview-container">
      <div class="overview-container_title text-center">{{ $t("project.chart.present_week_status") }}</div>
      <div class="overview-container_chart">
        <PresentWeekStatus/>
      </div>
    </div>
  </div>
</template>

<script>
import ProjectLayout from "./ProjectLayout";
import ProjectAmount from "./ProjectChart/ProjectAmount";
import ManmonthAmount from "./ProjectChart/ManmonthAmount";
import PersonInChargeManmonth from "./ProjectChart/PersonInChargeManmonth";
import PersonInChargeProjects from "./ProjectChart/PersonInChargeProjects";
import PresentWeekStatus from "./ProjectChart/PresentWeekStatus";

export default {
  name: "ProjectOverview",
  components: {
    ProjectLayout,
    ProjectAmount,
    ManmonthAmount,
    PersonInChargeManmonth,
    PersonInChargeProjects,
    PresentWeekStatus
  },
  data() {
    return {
    };
  },
  created() {
  }
};
</script>

<style lang="scss" scoped>
.project-overview {
  margin: -2rem -2rem 2rem -2rem;
  .manmonth-count {
    margin-top: 10px;
  }
  .manager-statistic {
    margin-bottom: 10px;
    margin-top: 10px;
  }
  .overview-container {
    background-color: #FFFFFF;
    //border-color: #d8dbe0;
    &.first {
      border-top: 1px solid #EFEFEF;
      border-top-right-radius: 0;
      border-top-left-radius: 0;
    }
    &_title {
      font-family: "Helvetica Neue", sans-serif;
      padding: 24px;
      color: #303C54;
      font-size: 18px;
      font-weight: 700;
      line-height: 22px;
      //border-bottom: 1px solid #CFCFCF;
    }
    &_title:after {
      content: "";
      display: block;
      padding-bottom: 24px;
      border-bottom: 1px solid #CFCFCF;
    }
    &_chart {
      padding: 0 30px 30px 30px;
    }
  }
}

</style>
